export const APP_ROOT_PATH = '/app';
export const APP_REGISTER_PATH = `${APP_ROOT_PATH}/register`;
export const APP_REQUESTS_PATH = `${APP_ROOT_PATH}/requests`;
export const APP_REQUEST_DETAIL_PATH = `${APP_REQUESTS_PATH}/:requestId`;
export const APP_TEMPLATES_PATH = `${APP_ROOT_PATH}/templates`;
export const APP_AGENTS_PATH = `${APP_ROOT_PATH}/agents`;
export const APP_PROVIDERS_PATH = `${APP_ROOT_PATH}/providers`;
export const APP_SETTLEMENT_PATH = `${APP_ROOT_PATH}/settlement`;
export const APP_DISPUTES_PATH = `${APP_ROOT_PATH}/disputes`;
export const APP_POLICIES_PATH = `${APP_ROOT_PATH}/policies`;
export const APP_DASHBOARD_PATH = `${APP_ROOT_PATH}/dashboard`;
export const APP_AUTH_CALLBACK_PATH = `${APP_ROOT_PATH}/auth/callback`;
